var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isVisible)?_c('div',{staticClass:"content-container container-fluid mb-7 mb-md-8"},[_c('h1',{staticClass:"mb-md-3 mb-2"},[_vm._v(_vm._s(_vm.headline))]),_c('h2',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.errorMessage)}})])]):_c('div',[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }